import React from "react";
import "../css/About.css";

const About = () => {
  return (
    <div className="about">

      {/* ================= HERO ================= */}
      <section className="ab-hero">
        <div className="ab-hero-text">
          <h1>THE ACE MINDSET</h1>
          <p>
            Built on discipline, sharpened by repetition, and fueled by purpose.
          </p>
        </div>

        <img 
          src="https://images.unsplash.com/photo-1605296867304-46d5465a13f1"
          alt="ACE Vision"
        />
      </section>


      {/* ================= STORY SPLIT ================= */}
      <section className="ab-story">
        <div className="ab-story-left">
          <h2>OUR ORIGIN</h2>

          <p>
            ACE began as a training philosophy focused on athletes chasing long-term 
            progress — not shortcuts. A system where performance, mindset, and science 
            collide to build athletes who last.
          </p>

          <p>
            What started as a small movement grew into a culture shaped by discipline,
            precision, and intensity — now redefining how modern athletes train.
          </p>
        </div>

        <div className="ab-story-right">
          <div className="story-overlay"></div>
          <img 
            src="https://images.pexels.com/photos/9945197/pexels-photo-9945197.jpeg"
            alt="ACE Journey"
          />
        </div>
      </section>


      {/* ================= TIMELINE ================= */}
      <section className="ab-timeline">
        <h2 className="section-title">ACE EVOLUTION</h2>

        <div className="timeline-wrap">

          <div className="tl-item">
            <span className="tl-year">2016</span>
            <p>ACE philosophy introduced — built around athletic longevity.</p>
          </div>

          <div className="tl-item">
            <span className="tl-year">2018</span>
            <p>First ACE programs launched with transformational results.</p>
          </div>

          <div className="tl-item">
            <span className="tl-year">2021</span>
            <p>Integrated precision-coaching & form analytics.</p>
          </div>

          <div className="tl-item">
            <span className="tl-year">2024</span>
            <p>ACE expands globally — becoming a complete athletic culture.</p>
          </div>

        </div>
      </section>


      {/* ================= MISSION GRID ================= */}
      <section className="ab-mission">
        <h2 className="section-title">OUR MISSION</h2>

        <div className="mission-grid">

          <div className="mission-card">
            <h3>BUILD DISCIPLINE</h3>
            <p>
              A technique-first approach that pushes consistency above everything else.
            </p>
          </div>

          <div className="mission-card">
            <h3>EMPOWER ATHLETES</h3>
            <p>
              Train the mind and body together for a stronger, sustainable future.
            </p>
          </div>

          <div className="mission-card">
            <h3>TRANSFORM CULTURE</h3>
            <p>
              ACE is more than fitness — it's a movement grounded in purpose.
            </p>
          </div>

        </div>
      </section>


      {/* ================= STATS ================= */}
      <section className="ab-stats">
        <div className="ab-stat">
          <h1>8+</h1>
          <p>Years of Innovation</p>
        </div>

        <div className="ab-stat">
          <h1>12K+</h1>
          <p>Athletes Trained</p>
        </div>

        <div className="ab-stat">
          <h1>40+</h1>
          <p>Elite Programs</p>
        </div>
      </section>


      {/* ================= PARALLAX PANEL ================= */}
      <section className="ab-parallax">
        <div className="parallax-text">
          <h1>DRIVEN BY PRECISION</h1>
          <p>Your performance is engineered — not accidental.</p>
        </div>
      </section>

    </div>
  );
};

export default About;
